import GlobalStyles from "./component/GlobalStyles";
import Home from "./component/Home";

function App() {
  return (
    <>
      <GlobalStyles />
      <Home />
    </>
  );
}

export default App;
